/**
 * Extracts a UUID from a URL query parameter, handling URL-encoded characters
 * and stripping any trailing garbage.
 *
 * @param emailParam - The email parameter value from the URL (may be URL-encoded)
 * @returns The extracted UUID string, or null if no valid UUID is found
 *
 * @example
 * extractEmailIdFromUrl("85b5ecc4-9319-409d-80d4-27b096e287e3%3E")
 * // Returns: "85b5ecc4-9319-409d-80d4-27b096e287e3"
 *
 * @example
 * extractEmailIdFromUrl("85b5ecc4-9319-409d-80d4-27b096e287e3")
 * // Returns: "85b5ecc4-9319-409d-80d4-27b096e287e3"
 */
export function extractEmailIdFromUrl(
  emailParam: string | null
): string | null {
  if (!emailParam || emailParam === "None") {
    return null;
  }

  // Try to decode URL-encoded characters first
  let decodedEmail: string;
  try {
    decodedEmail = decodeURIComponent(emailParam);
  } catch {
    // If decoding fails, use the original string
    decodedEmail = emailParam;
  }

  // Extract UUID pattern (8-4-4-4-12 hex characters) from the string
  const uuidMatch = decodedEmail.match(
    /([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/i
  );

  return uuidMatch ? uuidMatch[1] : null;
}
